<!-- <div class="footer-container">
  <div *ngIf="isMobile;else desktop_footer">
    <div>Subscribe and follow us on</div>
      <app-footer-share-icons></app-footer-share-icons>
  </div>
</div>

<ng-template #desktop_footer>
  <app-footer-share-icons></app-footer-share-icons>
</ng-template> -->
<div id="donation-form">
  <footer class="d-none d-sm-none d-lg-block">
    <div class="container footer-wrapper">
      <div class="row">
        <div class="col-md-3 col-lg-3 col-12 col-sm-7">
          <img loading="lazy" class="logo" data-src="https://d1vdjc70h9nzd9.cloudfront.net/images/logo-dark-bg.svg?w=80" width="80" height="40" alt="Online Crowdfunding"/>
          <div class="share-icons">
            <app-footer-share-icons></app-footer-share-icons>
          </div>
          <div class="followers">
            <h2 class="mb-0">{{variablesService.FOLLOWERS}}</h2>
            <span>Followers</span>
          </div>
          <div class="reach-out">
            <b>For any queries </b><br>
            <b>Email: info@ketto.org</b> <br>
            <b>Contact No: +91 {{ variablesService.contactUsMobNumber}}</b>
          </div>
          <!-- <ng-container *ngTemplateOutlet="footerLinks; context: { menu:footerObj.policies, class:'policies' }"></ng-container> -->
        </div>


        <div class="col-md-9 col-lg-9">
          <div class="container-fluid">
            <div class="row">
              <!-- <div class="col">
                <ng-container *ngTemplateOutlet="footerLinks; context: { menu:footerObj.fundraise, menuHeader:'Fundraisers' }"></ng-container>
              </div> -->
              <div class="col">
                <ng-container *ngTemplateOutlet="footerLinks; context: { menu:footerObj.causes, menuHeader:'Causes' }"></ng-container>
              </div>
              <div class="col">
                <ng-container *ngTemplateOutlet="footerLinks; context: { menu:footerObj.how_it_works, menuHeader:'How it works?' }"></ng-container>
              </div>
              <div class="col">
                <ng-container *ngTemplateOutlet="footerLinks; context: { menu:footerObj.aboutUs, menuHeader:'About Us' }"></ng-container>
              </div>
              <div class="col">
                <ng-container *ngTemplateOutlet="footerLinks; context: { menu:footerObj.support, menuHeader:'Support' }"></ng-container>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="copywrite-section d-none d-sm-block">
      <div class="container">
        <div class="row payment-methods-holder">
          <div class="offset-lg-6 payment-methods">
            <img loading="lazy" data-src="/assets/images/homepage/footer-secured-card.png?w=457" alt="secured image" width="100" height="30"/>
          </div>
        </div>
        <div class="row copyright" [ngClass]="{'padding-bottom-15': variablesService.isFundraiserEnded}">
          Copyright © {{currentYear}} Ketto Online Ventures Pvt Ltd. All Rights Reserved.
          <span *ngFor="let item of footerObj.policies; let last = last;">
            <a href="{{item.absoluteLink}}" target="_blank" rel="noopener">&nbsp;{{ item.text }}&nbsp;</a>
            <span *ngIf="!last">|</span>
          </span>
          <div class="disclaimer">
            Ketto is a private limited company operating an online intermediary platform providing crowdfunding services for medical, social and charitable causes. We facilitate transactions between contributors and campaigners. Ketto does not provide any financial benefits in any form whatsoever to any person making contributions on its platform.
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>

<ng-template #footerLinks let-menu="menu" let-menuHeader="menuHeader" let-type="class">
  <ul [ngClass]="type">
    <li *ngIf="menuHeader">
      <h4>
        {{ menuHeader }}
      </h4>
    </li>
    <li *ngFor="let item of menu">
        <a [href]="item.absoluteLink" (click)="onLinkClick(item)">
          {{ item.text }}
        </a>
    </li>
  </ul>
</ng-template>

<!--Mobile Footer-->

<footer class="d-lg-none d-sm-block" [ngClass]="{'pb-0': router.url === '/', 'mb-50': isBrowseFundrPage}">
  <div class="container">
    <div class="row upper-section">
      <div class="col-12 d-lg-none d-sm-block d-md-none subscribe-text">Subscribe and follow us on</div>
      <div class="col-sm-8 col-8">
        <div class="share-icons">
          <app-footer-share-icons></app-footer-share-icons>
        </div>
      </div>

      <div class="col-4 col-sm-4">
        <div class="followers">
          <h2>{{variablesService.FOLLOWERS}}</h2>
          <span>Followers</span>
        </div>
      </div>
    </div>
    <div class="row footer-bottom">
        <div class="col-12 logo-border">
            <img loading="lazy" class="logo" data-src="../assets/images/logo_white.png?w=80" width="80" height="40" alt="Online Crowdfunding"/>
        </div>
        <div class="col-12 footer-links">
            <ng-container *ngTemplateOutlet="footerLinks; context: { menu:footerObj.mobileMenu, menuHeader:'mobileMenu' }"></ng-container>
        </div>
        <div class="col-12 paymentmethods">
          <img loading="lazy" data-src="/assets/images/homepage/footer-mobile.png" alt="secured image" width="100" height="76" />
        </div>
        <div class="row copyright-mobile">
          Copyright © {{ currentYear}} Ketto Online Ventures Pvt Ltd. All Rights Reserved.
          <div class="disclaimer">
            Ketto is a private limited company operating an online intermediary platform providing crowdfunding services for medical, social and charitable causes. We facilitate transactions between contributors and campaigners. Ketto does not provide any financial benefits in any form whatsoever to any person making contributions on its platform.
          </div>
        </div>
    </div>
  </div>
</footer>
